import { OrdersDetailType } from "../interface";
import React from "react";

interface PropsType {
    ordersDetail: OrdersDetailType
}

export default function Tab1({ ordersDetail }: PropsType) {
    return <div className="content_wrap">
        <div className="table_scroll">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                    <tr>
                        <th style={{ width: "16.66%" }}>고객사</th>
                        <td style={{ width: "33.34%" }}>{ordersDetail.enduserName}</td>
                        <th style={{ width: "16.66%" }}>수주고객</th>
                        <td>{ordersDetail.contactName}</td>
                    </tr>
                    <tr>
                        <th>담당자</th>
                        <td>{ordersDetail.owningUserName}</td>
                        <th>요청자</th>
                        <td>{ordersDetail.chargeName}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div className="table_scroll">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                    <tr>
                        <th style={{ width: "16.66%" }}>발송요청일</th>
                        <td style={{ width: "33.34%" }}>{ordersDetail.newDtRequestShipment}</td>
                        <th style={{ width: "16.66%" }}>발송방법</th>
                        <td>{ordersDetail.newPShipmentName}</td>
                    </tr>
                    <tr>
                        <th>수신자</th>
                        <td>{ordersDetail.recipientName}</td>
                        <th>연락처</th>
                        <td>{ordersDetail.recipientMobilephone}</td>
                    </tr>
                    <tr>
                        <th>발송지</th>
                        <td colSpan={3}>{ordersDetail.addressName}</td>
                    </tr>
                    <tr>
                        <th>주소1</th>
                        <td>{ordersDetail.address1}</td>
                        <th>주소2</th>
                        <td>{ordersDetail.address2}</td>
                    </tr>
                    <tr>
                        <th>메모</th>
                        <td>{ordersDetail.newTxtMemo}</td>
                        <th>기타사항(거래명세서 비고)</th>
                        <td>{ordersDetail.newTxtNote}</td>
                    </tr>
                    <tr>
                        <th>고객메모</th>
                        <td colSpan={3}>{ordersDetail.customerMemo}</td>
                    </tr>
                    <tr>
                        <th>마감 구분</th>
                        <td>{ordersDetail.endType === "1"
                            ? "일반"
                            : ordersDetail.endType === "2"
                                ? "월마감"
                                : ordersDetail.endType === "3" ? "역발행" : ''}</td>
                        <th>매출 구분</th>
                        <td>{ordersDetail.salesType === "1"
                            ? "당월"
                            : ordersDetail.salesType === "2"
                                ? "이월"
                                : ""}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div className="table_scroll">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                    <tr>
                        <th style={{ width: "16.66%" }}>납품처</th>
                        <td style={{ width: "33.34%" }}>{ordersDetail.shipToName}</td>
                        <th style={{ width: "16.66%" }}>매출처</th>
                        <td>{ordersDetail.customerName}</td>
                    </tr>
                    <tr>
                        <th>수주일자</th>
                        <td>{ordersDetail.newDtOrder}</td>
                        <th>출하일자</th>
                        <td>{ordersDetail.newDtShipment}</td>
                    </tr>
                    <tr>
                        <th>수주 유형</th>
                        <td>{ordersDetail.orderTypeName}</td>
                        <th>Vat 구분</th>
                        <td>{ordersDetail.vatName}</td>
                    </tr>
                    <tr>
                        <th>산업 구분</th>
                        <td>{ordersDetail.industryName}</td>
                        <th>Application</th>
                        <td>{ordersDetail.applicationName}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                    <tr>
                        <th style={{ width: "16.66%" }}>수금예정일</th>
                        <td style={{ width: "33.34%" }}>{ordersDetail.newDtEstimatedCollection}</td>
                        <th style={{ width: "16.66%" }}>결제방법</th>
                        <td>{ordersDetail.paymentName}</td>
                    </tr>
                    <tr>
                        <th>수금메모(세금계산서 비고)</th>
                        <td colSpan={3}>{ordersDetail.newTxtCollection}</td>
                    </tr>
                    <tr>
                        <th>계산서담당자</th>
                        <td>{ordersDetail.taxCharge}</td>
                        <th>연락처</th>
                        <td>{ordersDetail.taxContact}</td>
                    </tr>
                    <tr>
                        <th>이메일</th>
                        <td colSpan={3}>{ordersDetail.taxEmail}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
}